// List of options for the svg select box. The file property matches the file name in the public folder.
const svgSelectOptions = [
    { label: 'Alpine', file: 'alpine' },
    { label: 'Angular', file: 'angular' },
    { label: 'Astro', file: 'astro' },
    { label: 'Bootstrap', file: 'bootstrap' },
    { label: 'Create React App', file: 'cra' },
    { label: 'CSS', file: 'css' },
    { label: 'Firebase', file: 'firebase' },
    { label: 'Gatsby', file: 'gatsby' },
    { label: 'Git', file: 'git' },
    { label: 'GraphQL', file: 'graphql' },
    { label: 'HTML', file: 'html' },
    { label: 'Javascript', file: 'javascript' },
    { label: 'JQuery', file: 'jquery' },
    { label: 'Laravel', file: 'laravel' },
    { label: 'Material UI', file: 'mui' },
    { label: 'Mongo DB', file: 'mongodb' },
    { label: 'MySQL', file: 'mysql' },
    { label: 'Netlify', file: 'netlify' },
    { label: 'Node JS', file: 'nodejs' },
    { label: 'Nuxt', file: 'nuxt' },
    { label: 'PHP', file: 'php' },
    { label: 'Postgres', file: 'postgres' },
    { label: 'Python', file: 'python' },
    { label: 'React', file: 'react' },
    { label: 'Recoil', file: 'recoil' },
    { label: 'Redux', file: 'redux' },
    { label: 'Sass', file: 'sass' },
    { label: 'Svelte', file: 'svelte' },
    { label: 'Tailwind', file: 'tailwind' },
    { label: 'Typescript', file: 'typescript' },
    { label: 'Vue', file: 'vue' },
];

export default svgSelectOptions;
